Promise.all([
    import("url-helper"),
    import("tap-ga/tap-ga").then(dep => dep.default),
    import("deprecate/main"),
    import("bootstrap/js/dist/dropdown"),
    import("auth-checker"),
    import("tap-side-menu/tap-side-menu"),
]).then(deps => {
    let [url, TapGA] = deps;

    const tapGA = new TapGA();
    tapGA.setEvents();
});
